module.exports = __webpack_public_path__ + "static/media/total-payment-transactions-blue.4b535e79.svg";